module.exports = __webpack_public_path__ + "img/cp-mp-r1.42116f8d.jpg";